import { Link } from "react-router-dom";
import { services } from "../../../mocks/siteData";

export default function ServicesOverview() {
  return (
    <section className="py-24 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
              What We Offer
            </span>
            <h2
              className="text-4xl lg:text-5xl font-semibold text-[#111111] leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Design Services Built
              <br />
              Around Your Space
            </h2>
          </div>
          <p className="text-[#5C5C5C] max-w-sm leading-relaxed">
            Every service is crafted to give you clarity, confidence, and a clear path forward — from first idea to finished space.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to="/services"
              className="group relative overflow-hidden rounded-xl cursor-pointer"
              style={{ height: "400px" }}
            >
              <img
                src={service.image}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>

              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <h3
                  className="text-lg font-semibold text-white mb-2 leading-tight"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {service.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 max-h-0 group-hover:max-h-24 overflow-hidden">
                  {service.description}
                </p>
                <div className="flex items-center gap-2 text-[#C9A961] text-sm font-medium">
                  <span>Learn More</span>
                  <div className="w-4 h-4 flex items-center justify-center translate-x-0 group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-xl p-8 border border-[#EBEBEB] flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p
              className="text-xl font-semibold text-[#111111] mb-1"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Not sure which service is right for you?
            </p>
            <p className="text-[#5C5C5C] text-sm">Tell us about your project and we&apos;ll recommend the best fit.</p>
          </div>
          <div className="flex items-center gap-4 shrink-0">
            <Link
              to="/services"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#111111] text-[#111111] font-medium px-6 py-3 rounded-md hover:bg-[#111111] hover:text-white transition-all duration-300 cursor-pointer text-sm"
            >
              View All Services
            </Link>
            <Link
              to="/#proposal"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#C9A961] text-white font-medium px-6 py-3 rounded-md hover:bg-[#b8924d] transition-colors duration-300 cursor-pointer text-sm"
            >
              Get Your Proposal
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
